import { Routes } from '@angular/router';
import { IvatypesComponent } from './pages/ivatypes/ivatypes.component';
import { IvapatternComponent } from './pages/ivatypes/sections/ivapattern/ivapattern.component';
import { LoginComponent } from './components/login/login.component';
import { TaxesComponent } from './pages/taxes/taxes.component';
import { AdministrationComponent } from './pages/administration/administration.component';
import { AcademictaxesComponent } from './pages/taxes/sections/academictaxes/academictaxes.component';
import { AdministrativeservicesComponent } from './pages/taxes/sections/administrativeservices/administrativeservices.component';
import { AdministrativetaxesComponent } from './pages/taxes/sections/administrativetaxes/administrativetaxes.component';
import { ModelComponent } from './pages/taxes/sections/model/model.component';
import { LearningresourcesComponent } from './pages/taxes/sections/learningresources/learningresources.component';
import { SendtaxesComponent } from './pages/taxes/sections/sendtaxes/sendtaxes.component';
import { SurchargesComponent } from './pages/taxes/sections/surcharges/surcharges.component';
import { IvatypessectionComponent } from './pages/ivatypes/sections/ivatypessection/ivatypessection.component';
import { LanguagesComponent } from './pages/administration/sections/languages/languages.component';
import { RolesComponent } from './pages/administration/sections/roles/roles.component';
import { UsersComponent } from './pages/administration/sections/users/users.component';
import { CoinsComponent } from './pages/coins/coins.component';
import { DiscountComponent } from './pages/discount/discount.component';
import { roleAdminGuard } from './core/guard/roleAdmin.guard';
import { CatalogDiscountComponent } from './pages/discount/sections/catalog-discount/catalog-discount.component';
import { TypesControlComponent } from './pages/discount/sections/types-control/types-control.component';
import { TypesControlDiscountComponent } from './pages/discount/sections/types-control-discount/types-control-discount.component';
import { EnrollmentComponent } from './pages/matricula/enrollment.component';
import { ModificationEnrollmentComponent } from './pages/matricula/sections/modification-enrollment/modification-enrollment.component';
import { CancellationEnrollmentComponent } from './pages/matricula/sections/cancellation-enrollment/cancellation-enrollment.component';
import { ServicesComponent } from './pages/administration/sections/services/services.component';
import { NoUserComponent } from './pages/core/no-user/no-user.component';
import { WelcomeComponent } from './pages/core/welcome/welcome.component';
import { authGuard } from './core/guard/auth.guard';
import { LauncherComponent } from './components/launcher/launcher.component';
import { RedirectLogoutComponent } from './components/redirect-logout/redirect-logout.component';
import { TuitionCalculationComponent } from './components/tuition-calculation/tuition-calculation.component';




export const routes: Routes = [

    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'front/login'
    },
    {
        path: 'front/login',
        component: LoginComponent
    },
    {
        path: 'front/ivatypes',
        component: IvatypesComponent,
        canActivate: [authGuard],
        data: { requiredRole: [""] }
    },
    {
        path: 'front/ivatypes/ivatypes',
        component: IvatypessectionComponent,
        canActivate: [authGuard],
        data: { requiredRole: ['ROLE_ADMIN', 'ROLE_GESTOR'] }
    },
    {
        path: 'front/ivatypes/ivapattern',
        component: IvapatternComponent,
        canActivate: [authGuard],
        data: { requiredRole: ['ROLE_ADMIN', 'ROLE_GESTOR'] }
    },
    {
        path: 'front/coins',
        component: CoinsComponent,
        canActivate: [],
        data: { requiredRole: [] }
    },
    {
        path: 'front/coins/coins',
        component: CoinsComponent,
        canActivate: [authGuard],
        data: { requiredRole: ['ROLE_ADMIN', 'ROLE_GESTOR'] }
    },
    {
        path: 'front/taxes',
        component: TaxesComponent,
        canActivate: [authGuard],
        data: { requiredRole: ['ROLE_ADMIN', 'ROLE_GESTOR'] }
    },
    {
        path: 'front/taxes/services',
        component: ServicesComponent,
        canActivate: [authGuard],
        data: { requiredRole: ['ROLE_ADMIN', 'ROLE_GESTOR'] }
    },
    {
        path: 'front/taxes/academic',
        component: AcademictaxesComponent,
        canActivate: [authGuard],
        data: { requiredRole: ['ROLE_ADMIN', 'ROLE_GESTOR'] }
    },
    {
        path: 'front/taxes/servicesAdministrative',
        component: AdministrativeservicesComponent,
        canActivate: [authGuard],
        data: { requiredRole: ['ROLE_ADMIN', 'ROLE_GESTOR'] }
    },
    {
        path: 'front/taxes/administrative',
        component: AdministrativetaxesComponent,
        canActivate: [authGuard],
        data: { requiredRole: ['ROLE_ADMIN', 'ROLE_GESTOR'] }
    },
    {
        path: 'front/taxes/models',
        component: ModelComponent,
        canActivate: [authGuard],
        data: { requiredRole: ['ROLE_ADMIN', 'ROLE_GESTOR'] }
    },
    {
        path: 'front/taxes/learning',
        component: LearningresourcesComponent,
        canActivate: [authGuard],
        data: { requiredRole: ['ROLE_ADMIN', 'ROLE_GESTOR'] }
    },
    {
        path: 'front/taxes/send',
        component: SendtaxesComponent,
        canActivate: [authGuard],
        data: { requiredRole: ['ROLE_ADMIN', 'ROLE_GESTOR'] }
    },
    {
        path: 'front/taxes/surcharge',
        component: SurchargesComponent,
        canActivate: [authGuard],
        data: { requiredRole: ['ROLE_ADMIN', 'ROLE_GESTOR'] }
    },
    {
        path: 'front/discounts',
        component: DiscountComponent,
        canActivate: [authGuard],
        data: { requiredRole: ['ROLE_ADMIN', 'ROLE_GESTOR'] }
    },
    {
        path: 'front/discounts/catalog',
        component: CatalogDiscountComponent,
        canActivate: [authGuard],
        data: { requiredRole: ['ROLE_ADMIN', 'ROLE_GESTOR'] }
    },
    {
        path: 'front/discounts/controlTypes',
        component: TypesControlComponent,
        canActivate: [authGuard],
        data: { requiredRole: ['ROLE_ADMIN', 'ROLE_GESTOR'] }
    },
    {
        path: 'front/discounts/discountControl',
        component: TypesControlDiscountComponent,
        canActivate: [authGuard],
        data: { requiredRole: ['ROLE_ADMIN', 'ROLE_GESTOR'] }
    },
    {
        path: 'front/enrollment',
        component: EnrollmentComponent,
        canActivate: [authGuard],
        data: { requiredRole: ['ROLE_ADMIN', 'ROLE_GESTOR'] }
    },
    {
        path: 'front/enrollment/modification',
        component: ModificationEnrollmentComponent,
        canActivate: [authGuard],
        data: { requiredRole: ['ROLE_ADMIN', 'ROLE_GESTOR'] }
    },
    {
        path: 'front/enrollment/cancellation',
        component: CancellationEnrollmentComponent,
        canActivate: [authGuard],
        data: { requiredRole: ['ROLE_ADMIN', 'ROLE_GESTOR'] }
    },
    {
        path: 'front/noUser',
        component: NoUserComponent
    },
    {
        path: 'front/welcome',
        component: WelcomeComponent,
        canActivate: [authGuard],
        data: { requiredRole: ['ROLE_ADMIN', 'ROLE_GESTOR'] }
    },
    {
        path: 'front/administration',
        component: AdministrationComponent,
        canActivate: [roleAdminGuard],
        data: { requiredRole: 'ROLE_ADMIN' }
    },
    {
        path: 'front/administration/languages',
        component: LanguagesComponent,
        canActivate: [roleAdminGuard],
        data: { requiredRole: 'ROLE_ADMIN' }
    },
    {
        path: 'front/administration/roles',
        component: RolesComponent,
        canActivate: [roleAdminGuard],
        data: { requiredRole: 'ROLE_ADMIN' }

    },
    {
        path: 'front/administration/users',
        component: UsersComponent,
        canActivate: [roleAdminGuard],
        data: { requiredRole: 'ROLE_ADMIN' }
    },
    {
        path: 'front/launcher',
        component: LauncherComponent,
        canActivate: [roleAdminGuard],
        data: { requiredRole: 'ROLE_ADMIN' }
    },
    {
        path: 'front/launcher/launcher',
        component: LauncherComponent,
        canActivate: [roleAdminGuard],
        data: { requiredRole: 'ROLE_ADMIN' }
    },
    {
        path: 'front/tuition-calculation',
        component: TuitionCalculationComponent,
        canActivate: [roleAdminGuard],
        data: { requiredRole: 'ROLE_ADMIN' }
    },
    {
        path: 'front/tuition-calculation/tuition-calculation',
        component: TuitionCalculationComponent,
        canActivate: [roleAdminGuard],
        data: { requiredRole: 'ROLE_ADMIN' }
    },
    {
        path: 'front/redirect-logout',
        component: RedirectLogoutComponent
    },
    {
        path: '**',
        redirectTo: 'front/login'
    }

];
